import axios from "axios";

export const getTalentNetworkDisplay = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/talentnetworkdisplay/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editTalentNetworkDisplay = (careersClientId, data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/talentnetworkdisplay/edittalentnetworkdisplay/" +
        encodeURIComponent(careersClientId),
      data
    )
    .then((res) => res.data);
};
